// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICalculateScheduleRequestDto
 */
export interface ICalculateScheduleRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ICalculateScheduleRequestDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICalculateScheduleRequestDto
     */
    start_date: Date;
    /**
     * 
     * @type {string}
     * @memberof ICalculateScheduleRequestDto
     */
    frequency: ICalculateScheduleRequestDtoFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof ICalculateScheduleRequestDto
     */
    day_of_week?: ICalculateScheduleRequestDtoDayOfWeekEnum;
    /**
     * 
     * @type {number}
     * @memberof ICalculateScheduleRequestDto
     */
    first_day_of_month?: number;
    /**
     * 
     * @type {number}
     * @memberof ICalculateScheduleRequestDto
     */
    second_day_of_month?: number;
    /**
     * 
     * @type {string}
     * @memberof ICalculateScheduleRequestDto
     */
    month?: ICalculateScheduleRequestDtoMonthEnum;
    /**
     * 
     * @type {number}
     * @memberof ICalculateScheduleRequestDto
     */
    day_of_month?: number;
}

/**
* @export
* @enum {string}
*/
export enum ICalculateScheduleRequestDtoFrequencyEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum ICalculateScheduleRequestDtoDayOfWeekEnum {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}
/**
* @export
* @enum {string}
*/
export enum ICalculateScheduleRequestDtoMonthEnum {
    JANUARY = 'JANUARY',
    FEBRUARY = 'FEBRUARY',
    MARCH = 'MARCH',
    APRIL = 'APRIL',
    MAY = 'MAY',
    JUNE = 'JUNE',
    JULY = 'JULY',
    AUGUST = 'AUGUST',
    SEPTEMBER = 'SEPTEMBER',
    OCTOBER = 'OCTOBER',
    NOVEMBER = 'NOVEMBER',
    DECEMBER = 'DECEMBER'
}


/**
 * Check if a given object implements the ICalculateScheduleRequestDto interface.
 */
export function instanceOfICalculateScheduleRequestDto(value: object): value is ICalculateScheduleRequestDto {
    if (!('start_date' in value) || value['start_date'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    return true;
}

export function ICalculateScheduleRequestDtoFromJSON(json: any): ICalculateScheduleRequestDto {
    return ICalculateScheduleRequestDtoFromJSONTyped(json, false);
}

export function ICalculateScheduleRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICalculateScheduleRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'start_date': (new Date(json['start_date'])),
        'frequency': json['frequency'],
        'day_of_week': json['day_of_week'] == null ? undefined : json['day_of_week'],
        'first_day_of_month': json['first_day_of_month'] == null ? undefined : json['first_day_of_month'],
        'second_day_of_month': json['second_day_of_month'] == null ? undefined : json['second_day_of_month'],
        'month': json['month'] == null ? undefined : json['month'],
        'day_of_month': json['day_of_month'] == null ? undefined : json['day_of_month'],
    };
}

export function ICalculateScheduleRequestDtoToJSON(json: any): ICalculateScheduleRequestDto {
    return ICalculateScheduleRequestDtoToJSONTyped(json, false);
}

export function ICalculateScheduleRequestDtoToJSONTyped(value?: ICalculateScheduleRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_id': value['calendar_id'],
        'start_date': ((value['start_date']).toISOString().substring(0,10)),
        'frequency': value['frequency'],
        'day_of_week': value['day_of_week'],
        'first_day_of_month': value['first_day_of_month'],
        'second_day_of_month': value['second_day_of_month'],
        'month': value['month'],
        'day_of_month': value['day_of_month'],
    };
}

